import React, { useMemo } from "react";
import { buildBattleLogReportView } from "./battleLogReportAdapter";
import BattleReportSection from "../../pages/battle-simulation/BattleReportSection";
import "../../pages/css/events-results.css";

const asBattleFromReason = (reason = {}) => {
  const source = reason && typeof reason === "object" ? reason : {};
  if (source.payload && typeof source.payload === "object") {
    return {
      ...source.payload,
      _id: source.id,
      battleKey: source.battleKey,
      battleTime: source.battleTime,
      at: source.battleTime,
    };
  }
  return {
    _id: source.id,
    source: source.source || "aoz_battle_report",
    reportKey: source.reportKey,
    reportId: source.reportId,
    pbi: source.pbi,
    battleTime: source.battleTime,
    at: source.battleTime,
    attacker: source.attacker || null,
    defender: source.defender || null,
    participants: Array.isArray(source.participants) ? source.participants : [],
    captureTruth: source.captureTruth || {},
    eventPoints: source.eventPoints || {},
    attackerPoints: source.attackerPoints ?? null,
    defenderPoints: source.defenderPoints ?? null,
    location: source.location || null,
    reportPayload: source.reportPayload || {},
    battleInput: source.battleInput || {},
  };
};

export default function BattleReportModal({
  battle = null,
  reason = null,
  title = "Battle Report",
  subtitle = "",
  evidence = null,
  onClose,
}) {
  const reportBattle = useMemo(
    () => battle || asBattleFromReason(reason || {}),
    [battle, reason],
  );
  const reportView = useMemo(
    () => buildBattleLogReportView(reportBattle || {}),
    [reportBattle],
  );

  return (
    <div className="events-battle-report-modal-backdrop" onClick={onClose}>
      <div className="events-battle-report-modal" onClick={(event) => event.stopPropagation()}>
        <div className="events-battle-report-modal-header">
          <div>
            <h4>{title}</h4>
            <span>{subtitle || reportView?.title || "Battle report"}</span>
          </div>
          <button
            type="button"
            className="events-create-modal-close"
            onClick={onClose}
            aria-label="Close battle report"
          >
            x
          </button>
        </div>
        {evidence && <div className="events-battle-report-evidence">{evidence}</div>}
        <BattleReportSection
          battleReport={reportView?.battleReport || null}
          attackerProfile={reportView?.attackerProfile || null}
          defenderProfile={reportView?.defenderProfile || null}
          reportDiagnostics={reportView?.diagnostics || null}
          title="Battle Report"
          emptyMessage="No replay troop data was captured for this battle."
          showBonuses={false}
        />
      </div>
    </div>
  );
}
